import { useEffect, useState } from "react";
import { fetchDigitalKycData } from "../../../Services/ApiTestService/apiTestService";

const DigilockerResultPage = () => {
    const [clientId, setClientId] = useState(null);
    const [data, setData] = useState([])
    const [showData, setShowData] = useState(false)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const client_id = params.get("client_id");
        const status = params.get("status");

        if (status === "success" && client_id) {
            setClientId(client_id);

            // ✅ You can now call your API here

            const response = fetchDigitalKycData(client_id);

            if (response) {
                setData(response.data)
                setShowData(true)
            }

            else {
                console.log("error something went wrong")
            }

        }
    }, []);

    return (
        <div>
            {
                showData && data && (
                    <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-200 rounded-2xl shadow-xl p-3 overflow-scroll">
                        <h3 className="text-blue-800 font-semibold text-xl">Digilocker Data Summary</h3>
                        {/* maskedAdharNumber": "xxxxxxxx6198",
        "name": "John123",
        "gender": "M",
        "dob": "05-08-1997",
        "careOf": "S/O: Abrahom",
        "address": {
            "house": "631 B",
            "street": "Victory First Street",
            "landmark": "keezhputhupakkam Extension",
            "loc": "abc",
            "po": "Cheyyar",
            "dist": "Xyx",
            "subdist": "abc",
            "vtc": "abc",
            "pc": "654378",
            "state": "Uttar Pradesh",
            "country": "India"
        },
        "image" */}
                        <div className="text-sm text-gray-700 mt-2" >
                            <div className="w-50 h-50 rounded-full">
                                <img src={data.image} alt="" className="w-50 h-50 rounded-full object-cover" />
                            </div>
                            <p>
                                <strong>Client Id:</strong>{" "}
                                {data?.maskedAdharNumber}
                            </p>
                            <p>
                                <strong>Token:</strong>{" "}
                                {data?.name}
                            </p>

                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.gender}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.dob}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.careOf}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.address.house}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.address?.street}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.address?.landmark}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.address?.loc}
                            </p>
                            <p>
                                <strong>URL:</strong>{" "}
                                {data?.address?.po}
                            </p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default DigilockerResultPage;
